module.exports = __webpack_public_path__ + "img/row-anaerobic.1fc9a258.png";